export default "__VITE_ASSET__e9f32098__"